import notifee, {
  AndroidImportance,
  EventType,
  TimestampTrigger,
  TriggerType,
  AuthorizationStatus,
} from '@notifee/react-native';
import Toast from 'react-native-toast-message';

export async function showToastNotification(
  title: string,
  body: string,
  data?: any,
) {
  try {
    // Check permission
    const settings = await notifee.getNotificationSettings();

    const isPermissionGranted =
      settings.authorizationStatus === AuthorizationStatus.AUTHORIZED ||
      settings.authorizationStatus === AuthorizationStatus.PROVISIONAL;

    if (!isPermissionGranted) {
      // Fallback to toast if permission is not granted
      Toast.show({
        type: 'info',
        text1: title || 'Ludo Voice',
        text2: body,
        position: 'top',
        visibilityTime: 3500,
        autoHide: true,
        topOffset: 50,
        onPress: () => {
          if (!data) {
            return;
          }
        },
      });
      return;
    }

    // iOS: Remove previous notifications
    await notifee.cancelAllNotifications();

    // Create notification channel for Android
    const channelId = await notifee.createChannel({
      id: 'LudoVoice',
      name: 'Ludo Voice Notifications',
      importance: AndroidImportance.HIGH,
      vibration: false,
    });

    const notificationId = await notifee.displayNotification({
      title,
      body,
      data: data,
      android: {
        channelId,
        smallIcon: 'ic_launcher', // ensure this icon exists
        importance: AndroidImportance.HIGH,
        autoCancel: true,
        pressAction: {
          id: 'default',
        },
      },
      ios: {
        foregroundPresentationOptions: {
          alert: true,
          sound: false,
          badge: false,
        },
      },
    });

    // Auto-remove notification after 3.5 seconds
    setTimeout(() => {
      notifee.cancelNotification(notificationId);
    }, 3500);
  } catch (error) {
    console.warn('Error showing toast notification:', error);

    // Fallback toast on any error
    Toast.show({
      type: 'error',
      text1: 'Notification Error',
      text2: 'Could not show notification',
      position: 'top',
      visibilityTime: 3000,
    });
  }
}
